import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const CertificateTemplate = ({ signingAuthority, organizationDetails }) => {
  const configData = useSelector(state => state.configSlice);

  const userData = useSelector(state => state.userSlice);

  const [html, setHtml] = useState('');
  const [template, setTemplate] = useState(null);
  const fetchTemplate = async () => {
    const response = await axios.get(configData.config.certificateConfig.certificateLink);
    // const response = await axios.get("https://simulanislegacy.blob.core.windows.net/sso/certificates/skillvirtualUNO.html");
    // const response = await axios.get("https://simulanislegacy.blob.core.windows.net/sso/certificates/xr.html");
    // const response = await axios.get("https://simulanislegacy.blob.core.windows.net/sso/certificates/universalUNO.html");
    // const response = await axios.get("https://simulanislegacy.blob.core.windows.net/sso/certificates/universalUNO2.html");
    var htmlContent = response.data;
    setTemplate(htmlContent);
    return htmlContent;
  };

  useEffect(() => {
       fetchTemplate();
  },[signingAuthority, organizationDetails])

  const setContent = async () => {
    var htmlContent = template;
    if (!htmlContent) {
      htmlContent = await fetchTemplate();
    }
    let issuedDate = moment(new Date()).format("LL")

    htmlContent = htmlContent.replace("{{USER_NAME}}", userData.user.name);
    htmlContent = htmlContent.replace("{{ISSUED_DATE}}", issuedDate);
    htmlContent = htmlContent.replace("{{MODULE_NAME}}", "Module Name");
    htmlContent = htmlContent.replace("{{ PARENT_LOGO }}", configData.config.unoLogo);
    htmlContent = htmlContent.replace("{{ PRODUCT_LOGO }}", configData.config.logo );
    htmlContent = htmlContent.replace("{{ ORG_LOGO }}", organizationDetails.logo || "https://simulanislegacy.blob.core.windows.net/sso/logos/sampleOrgLogo.png");
    htmlContent = htmlContent.replace("{{ ORGANIZATION_NAME }}", organizationDetails.name);
    htmlContent = htmlContent.replace("{{ SIGNATURE }}", signingAuthority.signature || "https://simulanislegacy.blob.core.windows.net/sso/logos/sampleSignature.png");
    htmlContent = htmlContent.replace("{{ SIGNATORY }}", signingAuthority.name);
    htmlContent = htmlContent.replace("{{ DESIGNATION }}", signingAuthority.designation
    );
    let outcomes = "<li><span></span>Outcome From the Module</li>";
    htmlContent = htmlContent.replace("{{ OUTCOMES }}", outcomes);
    htmlContent = htmlContent.replace("{{ UUID }}", "d64dca6b-d182-4e70-9b56-3c8d0911de78");
    htmlContent = htmlContent.replace("{{ COURSE_DURATION }}", "30 Minutes");
    setHtml(htmlContent)
  }

  useEffect(() => {
    setContent();
  }, [signingAuthority, organizationDetails])
  return (
    <>
    <div dangerouslySetInnerHTML={{ __html: html }} />
    </>
  )
}

export default CertificateTemplate
